<template>
<v-btn-toggle dense :value="value" :color="(isUndefined(color)) ? buttonColor : color" background-color="transparent" mandatory  @change="updateValue">
  <v-btn :small="(small !== false)" :disabled="disabled" :value="item[itemValue]" v-for="item in items" :key="item[itemValue]">
    <v-icon :small="(small !== false)" left v-text="item[itemIcon]" v-if="!isUndefined(itemIcon)">mdi-web</v-icon>
    <span :class="(small !== false) ? 'ec-font-size10' : 'ec-font-size12'" v-text="item[itemText]"></span>
  </v-btn>
</v-btn-toggle>
</template>
<script>
import MixinLib from '@/libs/MixinLib'

import ValidationLib from '@/libs/ValidationLib'

export default {
  name: 'ComponentsItemsButtonToggle',

  mixins: [MixinLib],

  data () {
    return {
      validate: [],
      placeholder: '',
      error: false,
      errors: ''
    }
  },

  computed: {
  },

  created: function () {
    this.validate = ValidationLib.rules(this.name)
    this.placeholder = ValidationLib.placeholder(this.name)
  },

  mounted: function () {
  },

  methods: {
    updateValue: function (e) {
      this.$emit('update:value', e)
      this.$emit('change')
    },

    isError: function () {
      return (this.errors.length > 0)
    },

    confirm: async function () {
      return new Promise((resolve, reject) => {
        try {
          this.errors = ''
          for (var y = 0; y < this.validate.length; y++) {
            const err = this.validate[y](this.value)
            if (err !== true) {
              this.errors = err
              break
            }
          }
          if (this.isError()) {
            this.error = true
            return resolve(false)
          }
          this.error = false
          return resolve(true)
        } catch (e) {
          return reject(e)
        }
      })
    }
  },

  props: {
    name: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    itemText: {
      type: [String, Boolean],
      required: false,
      default: () => 'code'
    },
    itemValue: {
      type: [String, Boolean],
      required: false,
      default: () => 'name'
    },
    itemIcon: {
      type: String,
      required: false,
      default: () => ''
    },
    value: {
      type: String,
      required: true,
      default: () => ''
    },
    small: {
      type: [String, Boolean],
      required: false,
      default: () => false
    },
    loading: {
      type: [String, Boolean],
      required: false,
      default: () => false
    },
    disabled: {
      type: [String, Boolean],
      required: false,
      default: () => false
    },
    color: {
      ype: String,
      required: false,
      default: () => ''
    }
  }
}
</script>
